import * as React from 'react'
import { hashHistory, IndexRoute, Redirect, Route, Router } from 'react-router'
import { default as Loading } from '../../../app-core/lib/ui/loadingPulse'
import { Base_PageNotFound } from '../Base/Base.ui.PageNotFound'
import { Rout_onChange } from './Rout.onChange'
import { Rout_replace, Rout_to } from './Rout'
import { Rout_create } from './Rout.create'

export const router = (children: React.ReactNode) => (
    <Router history={hashHistory}>
        <Route path="/" onChange={Rout_onChange}>
            <IndexRoute component={Loading} />
            {Rout_create('/loading', Loading)}
            {children}
            {Rout_create('/not-found', Base_PageNotFound)}
            <Redirect from="*" to="/not-found" />
        </Route>
    </Router>
)

export function Rout_toLoading() {
    Rout_to('/loading')
}

export function Rout_replaceWithPageNotFound(entityName?: string) {
    Rout_replace('/not-found', { entity: entityName })
}
